<!--
/*
 * Страница валидации magic link — обмен email+token на JWT-пару
 */
-->
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/modules/auth/stores/authStore'
import { useUserStore } from '@/modules/user/stores/userStore'
import { useSettingsStore } from '@/modules/settings/store/settingsStore'
import { usePayStore } from '@/modules/pay/store/payStore'
import { EventLogger } from '@/utils/EventLogger'
import { ERouteNames } from '@/router/ERouteNames'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const authStore = useAuthStore()
const userStore = useUserStore()
const settingsStore = useSettingsStore()
const payStore = usePayStore()

const isLoading = ref(true)
const errorMessage = ref('')

onMounted(async () => {
  const email = route.query.email as string
  const token = route.query.token as string

  if (!email || !token) {
    EventLogger.error('MagicLinkPage', ['Отсутствуют параметры email или token в URL'])
    await router.replace({ name: ERouteNames.AUTH })
    return
  }

  const result = await authStore.validateMagicLink({ email, token })

  if (result.ok) {
    await Promise.all([userStore.getUserData(), settingsStore.getSettings()])
    localStorage.removeItem('referral_code')
    const paymentStarted = await payStore.tryStartPendingPayment()
    if (router.currentRoute.value.name !== ERouteNames.PROFILE) {
      await router.replace({ name: paymentStarted ? ERouteNames.PAYMENT : ERouteNames.HOME })
    }
  } else {
    EventLogger.error('MagicLinkPage', [`Ошибка валидации magic link: ${result.error}`])
    errorMessage.value = result.error || t('errors.invalidCode')
  }

  isLoading.value = false
})

const goToAuth = () => {
  router.push({ name: ERouteNames.AUTH })
}
</script>

<template>
  <div class="d-flex flex-column align-center justify-center ga-4 pa-4 magic-link-page">
    <template v-if="isLoading">
      <v-progress-circular indeterminate color="primary" size="48" />
      <div class="text-body-1">{{ t('payment.processing') }}</div>
    </template>

    <template v-else-if="errorMessage">
      <v-alert type="error" variant="tonal" max-width="400" max-height="100">
        {{ errorMessage }}
      </v-alert>
      <v-btn color="primary" variant="outlined" @click="goToAuth">
        {{ t('auth.login') }}
      </v-btn>
    </template>
  </div>
</template>

<style scoped>
.magic-link-page {
  min-height: calc(100vh - 100px);
}

:deep(.v-alert__content) {
  align-self: center;
}

:deep(.v-alert__prepend) {
  align-self: center;
}
</style>
